export default {
  install: (app, options) => {
    app.config.globalProperties.$upperCaseFormatter = (data) => {
      if(data && data != '' && data != null) {
        return String(data).charAt(0).toUpperCase() + String(data).slice(1)
      } else {
        return data
      }
    }
  }
}



export function upperCaseFormatter(data) {
  if(data && data != '' && data != null) {
    return String(data).charAt(0).toUpperCase() + String(data).slice(1)
  } else {
    return data
  }
}